import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../auth.service';
import { SnackbarService } from 'src/app/shared/snackbar.service';
import { SnackbarPannelClass } from 'src/app/shared/snackbar-panel';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm!: FormGroup;
  hideNew = true;
  hideConfirm = true;
  isLoading = false;
  token: string | null = null;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private snackbarService: SnackbarService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.resetPasswordForm = this.fb.group({
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]]
    });

    // Try snapshot first
    this.token = this.route.snapshot.queryParamMap.get('token');
    console.log('🔑 Token from snapshot:', this.token);

    // Also subscribe to queryParams in case snapshot misses it
    if (!this.token) {
      this.route.queryParams.subscribe(params => {
        this.token = params['token'] || null;
        console.log('🔑 Token from queryParams subscription:', this.token);
      });
    }
  }

  onSubmit(): void {
    console.log('🔑 onSubmit called');
    const newPassword = this.resetPasswordForm.get('newPassword')?.value;
    const confirmPassword = this.resetPasswordForm.get('confirmPassword')?.value;
    console.log('🔑 newPassword:', newPassword ? '***' : 'EMPTY');
    console.log('🔑 confirmPassword:', confirmPassword ? '***' : 'EMPTY');
    console.log('🔑 token:', this.token);

    if (!newPassword || !confirmPassword) {
      this.snackbarService.showSnackbar('Внесете ја лозинката', SnackbarPannelClass.Warn);
      return;
    }
    if (newPassword !== confirmPassword) {
      this.snackbarService.showSnackbar('Лозинките не се совпаѓаат', SnackbarPannelClass.Error);
      return;
    }
    if (!this.token) {
      this.snackbarService.showSnackbar('Невалиден линк за ресетирање', SnackbarPannelClass.Error);
      return;
    }

    this.isLoading = true;
    console.log('🔑 Calling resetPassword API...');

    this.authService.resetPassword(this.token, newPassword).subscribe({
      next: () => {
        this.isLoading = false;
        this.snackbarService.showSnackbar('Лозинката е успешно променета!', SnackbarPannelClass.Success);
        this.router.navigate(['/login']);
      },
      error: (err) => {
        this.isLoading = false;
        const message = err.error?.message || 'Настана грешка. Обидете се повторно.';
        this.snackbarService.showSnackbar(message, SnackbarPannelClass.Error);
      }
    });
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
